<template>
  <Menu as="div" class="relative text-left">
    <div>
      <menu-button as="template">
        <slot name="button">
          <plain-button
            :variant="variant"
            :icon="iconName"
            :icon-type="iconType"
            :icon-only="!$slots.menuButton"
          >
            <slot name="menuButton"></slot>
          </plain-button>
        </slot>
      </menu-button>
    </div>

    <teleport to="body" :disabled="!fixed">
      <transition
        enter-active-class="transition ease-out duration-100"
        enter-from-class="transform opacity-0 scale-95"
        enter-to-class="transform opacity-100 scale-100"
        leave-active-class="transition ease-in duration-75"
        leave-from-class="transform opacity-100 scale-100"
        leave-to-class="transform opacity-0 scale-95"
      >
        <menu-items
          class="mt-2 w-56 origin-top-right rounded-lg bg-white shadow-lg ring-0 focus:outline-0"
          :class="
            fixed
              ? ['fixed z-100', menuClass]
              : [
                  'absolute z-50',
                  left ? 'right-0' : 'left-0',
                  top ? '-top-4 -translate-y-full' : '',
                ]
          "
        >
          <div class="py-2">
            <slot></slot>
          </div>
        </menu-items>
      </transition>
    </teleport>
  </Menu>
</template>

<script setup lang="ts">
import { Menu, MenuButton, MenuItems } from '@headlessui/vue';
import { PropType } from 'vue';
import { ButtonVariant } from '@/model/button';

defineProps({
  iconName: {
    type: String,
    default: 'chevron-down',
  },
  iconType: {
    type: String,
    default: 'far',
  },
  left: {
    type: Boolean,
    default: false,
  },
  top: {
    type: Boolean,
    default: false,
  },
  fixed: {
    type: Boolean,
    default: false,
  },
  menuClass: {
    type: String,
    default: '',
  },
  variant: {
    type: String as PropType<ButtonVariant>,
    default: ButtonVariant.SOFT,
  },
});
</script>
